module.exports = __webpack_public_path__ + "static/img/device_count1.53417521.gif";